import { render, staticRenderFns } from "./veStuAssocActivityType.vue?vue&type=template&id=0e56c1cd&scoped=true"
import script from "./veStuAssocActivityType.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e56c1cd",
  null
  
)

export default component.exports